export const AppConstants = {
    TYPES: {
        CONVENTIONAL: 'Conventional',
        STUDENT_HOUSING: 'Student Housing'
    },
    STUDENT_SHORT_TEXT: 'Student',
    EXPLORE: 'EXPLORE' 
}


// WEBPACK FOOTER //
// ./src/app/shared/utils/app-constants.ts